// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__3pBvN"};